import Action, { ActionAllMoshaveran, ActionAllMoshaveranFetchError, ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import MoshaveranState from '../State/AllMoshaveranState'

const actionMoshaveranFetchError = (oldState: MoshaveranState, action: Action): MoshaveranState => {
    return { ...oldState, error: (action as ActionAllMoshaveranFetchError).message, loading: false }
}

const actionMoshaveranFetchLoading = (oldState: MoshaveranState, _action: Action): MoshaveranState => {
    return { ...oldState, loading: true, error: undefined }
}

const actionMoshaveran = (oldState: MoshaveranState, action: Action): MoshaveranState => {
    return { ...oldState, loading: false, error: undefined, data: (action as ActionAllMoshaveran).data }
}

const actionMoshaveranShow = (oldState: MoshaveranState, action: Action): MoshaveranState => {
    return { ...oldState, show : !oldState.show }
}


type Process = (oldState: MoshaveranState, action: Action) => MoshaveranState

export const AllMoshaveranReducer: Reducer<MoshaveranState, Action> = (state: MoshaveranState = {
    data: [], loading: false, error: undefined , show : false
}, action: Action): MoshaveranState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.ALL_MOSHAVERAN_LOAGING, actionMoshaveranFetchLoading)
    actionMap.set(ActionType.ALL_MOSHAVERAN_DATA, actionMoshaveran)
    actionMap.set(ActionType.ALL_MOSHAVERAN_ERROR, actionMoshaveranFetchError)
    actionMap.set(ActionType.ALL_MOSHAVERAN_SHOW, actionMoshaveranShow)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


